// src/components/subscription/CustomerPortalButton.jsx

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { IoSettingsOutline } from "react-icons/io5";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import "./CustomerPortalButton.css";

// ✅ NEW (Capacitor + RevenueCat + in-app browser)
import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { Purchases } from "@revenuecat/purchases-capacitor";

const CustomerPortalButton = ({ className = "", children, isPaidUser }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [busy, setBusy] = useState(false);

  // ✅ NEW: don’t show any button unless user is paid
  if (!isPaidUser) return null;

  const openPortal = async () => {
    try {
      setBusy(true);

      // ✅ NEW: Native (iOS/Android) -> open Store management page via RevenueCat managementURL
      if (Capacitor.isNativePlatform()) {
        const platform = Capacitor.getPlatform(); // "ios" | "android"
        const customerInfo = await Purchases.getCustomerInfo();
        const url = customerInfo?.managementURL;

        if (url) {
          await Browser.open({ url });
          return;
        }

        // ✅ Fallbacks if managementURL is missing
        if (platform === "ios") {
          await Browser.open({ url: "https://apps.apple.com/account/subscriptions" });
          return;
        }
        if (platform === "android") {
          await Browser.open({ url: "https://play.google.com/store/account/subscriptions" });
          return;
        }

        console.error("No management URL returned");
        alert("Não foi possível abrir as configurações de assinatura.");
        return;
      }

      // ✅ Web -> keep Stripe portal behavior as-is
      const createPortalSession = httpsCallable(functions, "create_portal_session");
      const result = await createPortalSession();
      const url = result.data?.url;

      if (url) {
        window.location.href = url;
      } else {
        console.error("No portal URL returned");
        alert("Não foi possível abrir o portal de cobrança.");
      }
    } catch (err) {
      console.error("Error opening portal", err);
      alert("Erro ao abrir o portal de cobrança.");
    } finally {
      setBusy(false);
    }
  };

  if (loading) {
    return <button className="profile-billing-btn disabled">Carregando…</button>;
  }

  if (user) {
    return (
      <button
        className={`profile-billing-btn ${className}`}
        onClick={openPortal}
        disabled={busy}
      >
        <IoSettingsOutline className="btn-icon" />
        {busy ? "Abrindo..." : children || "Configurar Assinatura"}
      </button>
    );
  }

  return (
    <button
      className={`profile-billing-btn ${className}`}
      onClick={() => navigate("/signin", { state: { from: location.pathname } })}
    >
      {children || "Entrar para gerenciar cobrança"}
    </button>
  );
};

export default CustomerPortalButton;

